// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:host {
  --page-margin: 8px;
  --page-background: var(--app-background);
  --page-border-radius: var(--app-fair-radius);
  --page-tags-vertical-gutter: 2px;
  --page-tags-horizontal-gutter: 4px;
  --page-places-gutter: 5px;
  --page-friends-gutter: calc(var(--page-margin) / 2);
  --page-visits-gutter: calc(var(--page-margin) / 2);
  --page-swiper-pagination-space: 40px;
  --page-swiper-pagination-height: 18px;
  --page-pagination-bullet-size: 10px;
  --page-color: #00AFFF;
}

.filter-chips {
  /* border-bottom: 1px solid var(--ion-color-light-shade); */
}
.filter-chips .chips-row {
  --ion-grid-columns: 7;
  --ion-grid-column-padding: 0px;
  flex-wrap: nowrap;
  overflow-x: scroll;
  will-change: scroll-position;
  margin-left: calc(var(--page-margin) * -1);
  margin-right: calc(var(--page-margin) * -1);
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
  scrollbar-width: none;
}
.filter-chips .chips-row::-webkit-scrollbar {
  display: none;
}
.filter-chips .chips-row::before, .filter-chips .chips-row::after {
  content: "";
  flex: 0 0 calc(var(--page-margin) - var(--page-visits-gutter));
}
.filter-chips .chips-row .chip-item {
  flex: 0 0 calc(var(--col-item-width) / var(--ion-grid-columns, 12) * 100%);
  width: calc(var(--col-item-width) / var(--ion-grid-columns, 12) * 100%);
  max-width: calc(var(--col-item-width) / var(--ion-grid-columns, 12) * 100%);
  padding: 0px var(--page-visits-gutter);
}
.filter-chips .chips-row .chip-item .visit-name {
  display: block;
  text-align: left;
  margin: var(--page-margin) 0px;
  font-size: 14px;
  padding-left: 4px;
}
.filter-chips .chips-row .chip-item .visit-name ion-chip {
  background-color: var(--ion-background-color);
  white-space: nowrap;
}
.filter-chips .chips-row .chip-item .visit-name ion-chip ion-icon {
  margin: 0 4px;
}
.filter-chips .chips-row .chip-item .visit-name ion-chip.selected {
  color: white;
  background-color: #3880ff;
}
.filter-chips .chips-row .chip-item .visit-name ion-chip.selected ion-icon {
  color: white;
}

ion-chip.selected {
  background-color: #a0a5ac;
  color: #152d59;
}

.highlighted-chip {
  border: 2px solid transparent; /* Inicialmente sin borde */
  transition: border 0.5s ease; /* Transición de borde */
  animation-name: highlightAnimation;
  animation-duration: 5s; /* Duración total del ciclo de la animación */
  animation-iteration-count: 4; /* Repetir 4 veces en total */
}

@keyframes highlightAnimation {
  0%, 100% {
    box-shadow: 0 0 10px yellow;
    border-color: yellow;
  }
  50% {
    box-shadow: none;
    border-color: transparent;
  }
}
.highlighted-chip-experiences {
  border: 2px solid transparent;
  transition: border 0.5s ease;
  animation-name: highlightAnimationExperiences;
  animation-duration: 5s;
  animation-iteration-count: 4;
}

@keyframes highlightAnimationExperiences {
  0%, 100% {
    box-shadow: 0 0 10px lime;
    border-color: lime;
  }
  50% {
    box-shadow: none;
    border-color: transparent;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/filter-chips/filter-chips.component.scss","webpack://./src/theme/mixins/scrollbars.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE,kBAAA;EACA,wCAAA;EACA,4CAAA;EAEA,gCAAA;EACA,kCAAA;EACA,yBAAA;EACA,mDAAA;EACA,kDAAA;EAEA,oCAAA;EACA,qCAAA;EACA,mCAAA;EAEA,qBAAA;AAHF;;AAMA;EAGI,2DAAA;AALJ;AAOI;EACE,qBAAA;EACA,8BAAA;EAEA,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,0CAAA;EACA,2CAAA;EC9BJ,wBAAA;EAGA,8BAAA;EACA,qBAAA;ADuBF;ACpBE;EACE,aAAA;ADsBJ;AAIM;EAEE,WAAA;EAEA,8DAAA;AAJR;AAOM;EAGE,0EAAA;EACA,uEAAA;EACA,2EAAA;EAEA,sCAAA;AARR;AAUQ;EACE,cAAA;EACA,gBAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;AARV;AAUU;EACE,6CAAA;EACA,mBAAA;AARZ;AAUY;EACE,aAAA;AARd;AAWY;EACE,YAAA;EACA,yBAAA;AATd;AAWc;EACE,YAAA;AAThB;;AAqBA;EACE,yBAAA;EACA,cAAA;AAlBF;;AAuBA;EACE,6BAAA,EAAA,2BAAA;EACA,4BAAA,EAAA,wBAAA;EAEA,kCAAA;EACA,sBAAA,EAAA,6CAAA;EACA,4BAAA,EAAA,6BAAA;AArBF;;AAyBA;EACE;IACE,2BAAA;IACA,oBAAA;EAtBF;EAwBA;IACE,gBAAA;IACA,yBAAA;EAtBF;AACF;AAyBA;EACE,6BAAA;EACA,4BAAA;EAEA,6CAAA;EACA,sBAAA;EACA,4BAAA;AAxBF;;AA4BA;EACE;IACE,yBAAA;IACA,kBAAA;EAzBF;EA2BA;IACE,gBAAA;IACA,yBAAA;EAzBF;AACF","sourcesContent":["@import \"theme/mixins/scrollbars\";\r\n\r\n:host {\r\n  --page-margin: 8px;\r\n  --page-background: var(--app-background);\r\n  --page-border-radius: var(--app-fair-radius);\r\n\r\n  --page-tags-vertical-gutter: 2px;\r\n  --page-tags-horizontal-gutter: 4px;\r\n  --page-places-gutter: 5px;\r\n  --page-friends-gutter: calc(var(--page-margin) / 2);\r\n  --page-visits-gutter: calc(var(--page-margin) / 2);\r\n\r\n  --page-swiper-pagination-space: 40px;\r\n  --page-swiper-pagination-height: 18px;\r\n  --page-pagination-bullet-size: 10px;\r\n\r\n  --page-color: #00AFFF;\r\n}\r\n\r\n.filter-chips {\r\n    // margin: calc(var(--page-margin) * 2) var(--page-margin) var(--page-margin);\r\n    // padding-bottom: var(--page-margin);\r\n    /* border-bottom: 1px solid var(--ion-color-light-shade); */\r\n\r\n    .chips-row {\r\n      --ion-grid-columns: 7; // We want to show three friends and a half. Each friend fills 2 cols => (3.5 * 2 = 7 cols)\r\n      --ion-grid-column-padding: 0px;\r\n\r\n      flex-wrap: nowrap;\r\n      overflow-x: scroll;\r\n      will-change: scroll-position;\r\n      margin-left: calc(var(--page-margin) * -1);\r\n      margin-right: calc(var(--page-margin) * -1);\r\n\r\n      @include hide-scrollbars();\r\n\r\n      &::before,\r\n      &::after {\r\n        content: '';\r\n        // .friend-item has 8px of side padding, we need an extra 4px at the beginning and end to fill the 12px side margin of the view\r\n        flex: 0 0 calc(var(--page-margin) - var(--page-visits-gutter));\r\n      }\r\n\r\n      .chip-item {\r\n        // --col-item-width: 3;\r\n        // SSR fix: Override ion-col styles\r\n        flex: 0 0 calc(calc(var(--col-item-width) / var(--ion-grid-columns, 12)) * 100%);\r\n        width: calc(calc(var(--col-item-width) / var(--ion-grid-columns, 12)) * 100%);\r\n        max-width: calc(calc(var(--col-item-width) / var(--ion-grid-columns, 12)) * 100%);\r\n\r\n        padding: 0px var(--page-visits-gutter);\r\n\r\n        .visit-name {\r\n          display: block;\r\n          text-align: left;\r\n          margin: var(--page-margin) 0px;\r\n          font-size: 14px;\r\n          padding-left: 4px;\r\n\r\n          ion-chip {\r\n            background-color: var(--ion-background-color);\r\n            white-space: nowrap;\r\n\r\n            ion-icon {\r\n              margin: 0 4px;\r\n            }\r\n\r\n            &.selected {\r\n              color: white;\r\n              background-color: #3880ff;\r\n\r\n              ion-icon {\r\n                color: white;\r\n              }\r\n            }\r\n\r\n\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n\r\nion-chip.selected {\r\n  background-color: #a0a5ac;\r\n  color: #152d59;\r\n}\r\n\r\n\r\n\r\n.highlighted-chip {\r\n  border: 2px solid transparent; /* Inicialmente sin borde */\r\n  transition: border 0.5s ease; /* Transición de borde */\r\n\r\n  animation-name: highlightAnimation;\r\n  animation-duration: 5s; /* Duración total del ciclo de la animación */\r\n  animation-iteration-count: 4; /* Repetir 4 veces en total */\r\n}\r\n\r\n\r\n@keyframes highlightAnimation {\r\n  0%, 100% {\r\n    box-shadow: 0 0 10px yellow;\r\n    border-color: yellow;\r\n  }\r\n  50% {\r\n    box-shadow: none;\r\n    border-color: transparent;\r\n  }\r\n}\r\n\r\n.highlighted-chip-experiences {\r\n  border: 2px solid transparent;\r\n  transition: border 0.5s ease;\r\n\r\n  animation-name: highlightAnimationExperiences;\r\n  animation-duration: 5s;\r\n  animation-iteration-count: 4;\r\n}\r\n\r\n\r\n@keyframes highlightAnimationExperiences {\r\n  0%, 100% {\r\n    box-shadow: 0 0 10px lime;\r\n    border-color: lime;\r\n  }\r\n  50% {\r\n    box-shadow: none;\r\n    border-color: transparent;\r\n  }\r\n}\r\n","// Hide scrollbars: https://stackoverflow.com/a/38994837/1116959\r\n@mixin hide-scrollbars() {\r\n  // IE 10+\r\n  -ms-overflow-style: none;\r\n\r\n  // Firefox\r\n  overflow: -moz-scrollbars-none;\r\n  scrollbar-width: none;\r\n\r\n  // Safari and Chrome\r\n  &::-webkit-scrollbar {\r\n    display: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
